import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ApiAmountWithCurrency } from '../api';
import { formatAmountInCurrency } from '../utils';
import { IPointLoyalty } from '../utils/types';

type PaymentCardItemProps = {
  firstName: string;
  lastName: string;
  balance: ApiAmountWithCurrency;
  total: ApiAmountWithCurrency;
  toPay: ApiAmountWithCurrency;
  loyalty?: IPointLoyalty;
};

export function PaymentCard(props: PaymentCardItemProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: '180px',
        maxWidth: '180px',
        minWidth: 'min-content',
        border: '2px solid #DBDBDB',
        borderRadius: '10px',
        p: 3,
      }}
    >
      <Typography sx={{ color: 'inherit' }}>
        {props.firstName || props.lastName
          ? `${props.firstName} ${props.lastName}`
          : '-'}
      </Typography>

      <Typography
        sx={{
          border: '2px solid #DBDBDB',
          p: 2,
          bg: '#FFFCF0',
          borderRadius: '5px',
          mt: 2,
          width: '100%',
          textAlign: 'center',
        }}
      >
        {formatAmountInCurrency(
          props.toPay.amount,
          props.toPay.currency.code || 'TRY',
        )}
      </Typography>

      {(props.loyalty?.fiat || 0) > 0 &&
        props.loyalty?.currencyExchangeRate && (
          <Typography variant="caption" mt={1}>
            {formatAmountInCurrency(
              props.loyalty.fiat / props.loyalty.currencyExchangeRate || 0,
              props.toPay.currency.code || 'TRY',
            )}{' '}
            {t('paymentCard.usedPoint')}
          </Typography>
        )}
    </Box>
  );
}
